import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TraderBalances } from './types'

interface TraderBalancesState {
  balances: TraderBalances[]
  loading: boolean
  error: string | null
}

const initialState: TraderBalancesState = {
  balances: [],
  loading: false,
  error: null,
}

const balancesSlice = createSlice({
  name: 'balances',
  initialState,
  reducers: {
    fetchBalancesStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchBalancesSuccess: (state, action: PayloadAction<TraderBalances[]>) => {
      state.balances = action.payload
      state.loading = false
    },
    fetchBalancesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const { fetchBalancesStart, fetchBalancesSuccess, fetchBalancesFailure } =
  balancesSlice.actions
export default balancesSlice.reducer
